import React from "react";
import MySowTableList from "./components/MySowTableList";

function BidManagement() {
  return <MySowTableList />;
}

export default BidManagement;
